// General mixin for shared functionality among Vue instances
const mixin = {
    methods: {
        // Simple whitespace strip function.
        strip(value) {
            if (!value) return '';
            value = value.toString();
            return value.replace(/\s/g, '');
        },
        // Simple date object handler.
        toDateObj(dateString) {
            return new Date(dateString);
        },
        // Simple short date string handler for date.
        toShortDateStr(dateString) {
            return new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' }).replace('.', '');
        },
        // Simple date string handler for date and time.
        toDateTimeStr(dateString) {
            let date = new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
            let time = new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
            return date.replace('.', '') + ' ' + time;
        },
        // Simple short day string handler for date.    
        toShortDayStr(dateString) {
            return new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short' }).replace('.', '');
        },
        // Simple short day month string handler for date.    
        toShortDayMonthStr(dateString) {
            return new Date(dateString).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' }).replace('.', '');
        },
        // Simple long day month string handler for date.    
        toLongDayMonthStr(dateString) {
            return new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' }).replace('.', '');
        },
        // Simple short year string handler for date.
        toYearStr(dateString) {
            return new Date(dateString).toLocaleDateString('nl-NL', { year: 'numeric' });
        },
        // Simple timestring handler for date.
        toShortTimeStr(dateString) {
            return new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
        },
        // Date string handler for time.
        toTimeStr(dateString, endDateString) {
            let startTime = new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
            let endTime = endDateString ? new Date(endDateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' }) : null;
            return endTime ? startTime + ' - ' + endTime : startTime;
        },
        // Simple date string handler.
        toDateStr(dateString) {
            let date = new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
            let time = new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
            return date.replace('.', '') + ' | ' + time;
        },
        // Simple array reverser.
        reverse(array) {
            return [...array].reverse();
        },
        // General debounce function for reducing unnecessary API calls.
        debounce(cb, delay = 500) {
            let timeout;
            return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                cb(...args)
            }, delay)}
        },
        toMediaQuery(mediaString) {
            if (!mediaString) return '';
            return mediaString.split('"')[1];
        },
        // Buttonstyle function.
        buttonStyle(buttonColor) {
            if (!buttonColor) return {};
            return { backgroundColor: buttonColor, borderColor: buttonColor }
        }
    }
}

export default mixin;
